import React from "react";
import styled from "styled-components";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Close from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

const StyledDialog = styled.div``;

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 35rem;
  margin-top: 3rem;
  box-shadow: 0 2rem 4rem rgba(0, 0, 0, 0.06);
  border: 1px solid #f4f2f2;
  // shadow: 0 2rem 6rem rgba(0,0,0,.3)

  // shadow: 0 2rem 6rem rgba(0,0,0,.3)
`;

const StyledHeader = styled.div`
  text-transform: uppercase;
  font-weight: 400;
  font-size: 16px;
  padding: 2rem;

  @media (max-width: 800px) {
    font-size: 15px;
  }
`;

const List = styled.ul`
  list-style-type: none;
`;

const ListItem = styled.li`
  padding-bottom: 1rem;
`;

const StyledText = styled.div`
  position: absolute;
  right: 0;
  bottom: 0px;
  font-size: 15px;
  font-weight: 300;
  left: 4rem;
  z-index: 90;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 1rem;

  @media (max-width: 700px) {
    font-size: 14px;
  }

  @media (max-width: 325px) {
    left: 2rem;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  position: relative;
  height: auto;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 24rem;
  object-fit: cover;
  object-position: 50% 100%;
`;

const StyledButton = styled(Button)`
  &&& {
    position: relative;
    float: right;
    font-size: 16px;
    color: gray;
    padding-right: 4px;
  }
`;

const StyledTypo = withStyles({
  root: {
    color: "gray",
    fontWeight: 400,
    fontSize: "16px",
    paddingBottom: "1rem",
    textAlign: "justify"
  }
})(Typography);

const BackTitle = styled.h2`
  color: gray;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 20px;
  padding: 2rem;
`;

const Figure = styled.div`
  display: grid;
  grid-template-rows: repeat(2, min-content);
`;

const ImagePart = styled.div`
  display: grid;
  grid-template-rows: repeat(5, minmax(min-content, 1fr));
  grid-template-columns: repeat(7, minmax(min-content, 1fr));
`;

const Image = styled.img`
  width: 80%;
  box-shadow: 0 1.5rem 4rem rgba(0, 0, 0, 0.4);
  border-radius: 2px;
  z-index: 10;
  transition: all 0.2s;
  outline-offset: 2rem;

  &:hover {
    transform: scale(1.2) translateY(-0.5rem);
    z-index: 20;
  }
`;

const ImageP1 = styled(Image)`
  grid-row: 2 / 6;
  grid-column: 2 / 6;
`;

const ImageP2 = styled(Image)`
  grid-row: 1 / 4;
  grid-column: 3 / 7;
`;

const ImageP3 = styled(Image)`
  grid-row: 3 / 5;
  grid-column: 4 / 8;
`;

const Caption = styled.div`
  text-align: center;
`;

class ContentCard extends React.Component {
  state = {
    open: false,
    scroll: "paper"
  };

  handleClickOpen = scroll => () => {
    this.setState({ open: true, scroll });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <StyledDialog>
        <StyledCard onClick={this.handleClickOpen("paper")}>
          <StyledHeader>{this.props.title}</StyledHeader>
          <ImageContainer>
            <StyledImage src={this.props.image} alt={this.props.imageText} />
            {this.props.frontText ? (
              <StyledText>{this.props.frontText}</StyledText>
            ) : null}
          </ImageContainer>
          <div>
            <StyledButton
              aria-label="More"
              variant="text"
              onClick={this.handleClickOpen("paper")}
            >
              More
              <KeyboardArrowRight />
            </StyledButton>
          </div>
        </StyledCard>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={this.state.scroll}
          aria-labelledby="scroll-dialog-title"
        >
          <BackTitle id="scroll-dialog-title">{this.props.title}</BackTitle>
          <DialogContent>
            <DialogContentText>
              {this.props.item1 ? (
                <List>
                  <ListItem>{this.props.item1}</ListItem>
                  <ListItem>{this.props.item2}</ListItem>
                  <ListItem>{this.props.item3}</ListItem>
                  <ListItem>{this.props.item4}</ListItem>
                  <ListItem>{this.props.item5}</ListItem>
                  <ListItem>{this.props.item6}</ListItem>
                  <ListItem>{this.props.item7}</ListItem>
                  <ListItem>{this.props.item8}</ListItem>
                  <ListItem>{this.props.item9}</ListItem>
                  <ListItem>{this.props.item10}</ListItem>
                  <ListItem>{this.props.item11}</ListItem>
                </List>
              ) : null}

              <StyledTypo>{this.props.backTextOne}</StyledTypo>
              <StyledTypo>{this.props.backTextTwo}</StyledTypo>
              <StyledTypo>{this.props.backTextThree}</StyledTypo>
              {this.props.backTextFour ? (
                <StyledTypo>{this.props.backTextFour}</StyledTypo>
              ) : null}
              {this.props.backTextFive ? (
                <StyledTypo>{this.props.backTextFive}</StyledTypo>
              ) : null}
              {this.props.imageBack1 ||
              this.props.imageBack2 ||
              this.props.imageBack3 ? (
                <Figure>
                  <ImagePart>
                    {this.props.imageBack1 ? (
                      <ImageP1
                        src={this.props.imageBack1}
                        alt={this.props.imageTitle1}
                      />
                    ) : null}
                    {this.props.imageBack2 ? (
                      <ImageP2
                        src={this.props.imageBack2}
                        alt={this.props.imageTitle2}
                      />
                    ) : null}
                    {this.props.imageBack3 ? (
                      <ImageP3
                        src={this.props.imageBack3}
                        alt={this.props.imageTitle3}
                      />
                    ) : null}
                  </ImagePart>
                  {this.props.caption ? (
                    <Caption>{this.props.caption}</Caption>
                  ) : null}
                </Figure>
              ) : null}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <IconButton onClick={this.handleClose} color="gray">
              <Close />
            </IconButton>
          </DialogActions>
        </Dialog>
      </StyledDialog>
    );
  }
}

export default ContentCard;



// WEBPACK FOOTER //
// ./src/UI/ContentCard/ContentCard.js